
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","id":"Typing--Streamline-Streamline--3.0.svg","height":"24","width":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('desc',[_v('Typing Streamline Icon: https://streamlinehq.com')]),_c('defs'),_c('title',[_v('typing')]),_c('path',{attrs:{"d":"M2.25 5.249h19.5s1.5 0 1.5 1.5v10.5s0 1.5 -1.5 1.5H2.25s-1.5 0 -1.5 -1.5v-10.5s0 -1.5 1.5 -1.5","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"m6.75 15.749 0 -7.5","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"m5.25 8.249 3 0","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"m5.25 15.749 3 0","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}})])
          )
        }
      }
    